import { buildInitialState as buildInitialDateRangeState } from '@components/Kendo/DateRangePickerReducer';
import LinkTableCell from '@components/Kendo/LinkTableCell';
import { translate } from '@utils/i18n';
import ActionsCell from './nested/ActionsCell';
import IssueDateCell from './nested/IssueDateCell';
import InvoiceNoCell from './nested/InvoiceNoCell';
import QbInvoiceNoCell from './nested/QbInvoiceNoCell';

export const namespace = 'features.invoices.index.table.headers';

export const INITIAL_PAGE_SKIP = 0;

export const INITIAL_PAGE = { skip: INITIAL_PAGE_SKIP, take: 25 };

export const INITIAL_SORT = [
  {
    field: 'id',
    dir: 'desc'
  }
];

export const INITIAL_FILTERS = {
  values: {
    inspectionId: '',
    workOrderId: '',
    building: '',
    status: '',
    invoiceNumber: '',
    account: '',
    category: '',
    linkedToQbo: '',
    sent: '',
    overdue: '',
    recurringInvoice: '',
    additionalTerritory: '',
    ...buildInitialDateRangeState('issueDate'),
    ...buildInitialDateRangeState('dueDate'),
    ...buildInitialDateRangeState('paidDate')
  },
  active: {
    inspectionId: false,
    workOrderId: false,
    building: true,
    status: true,
    invoiceNumber: true,
    account: true,
    category: false,
    linkedToQbo: false,
    sent: false,
    overdue: false,
    recurringInvoice: true,
    additionalTerritory: false,
    issueDate: false,
    dueDate: false,
    paidDate: false
  },
  operators: {
    invoiceNumber: 'contains'
  }
};

export const DEFAULT_COLUMNS = [
  'invoiceNo',
  'invoiceFor',
  'building',
  'issueDate',
  'account',
  'technician',
  'status',
  'invoiceAmount',
  'balance',
  'actions'
];

// Everything the grid can show. The column menu is built from this in code, so a column added here
// is offered to existing users too -- it is DEFAULT_COLUMNS that decides what starts visible.
export const ALL_COLUMNS = [
  'invoiceNo',
  'qbInvoiceNo',
  'referenceNumber',
  'invoiceFor',
  'building',
  'issueDate',
  'account',
  'technician',
  'status',
  'invoiceAmount',
  'balance',
  'actions'
];

export const ALL_COLUMNS_DATA = {
  invoiceNo: {
    id: 'invoiceNo',
    field: 'invoiceNo',
    title: translate('invoice_no', { namespace }),
    cell: InvoiceNoCell,
    className: 'invoice-no-column'
  },
  qbInvoiceNo: {
    id: 'qbInvoiceNo',
    field: 'qboInvoiceId',
    title: translate('qb_invoice_no', { namespace }),
    cell: QbInvoiceNoCell
  },
  invoiceFor: {
    id: 'invoiceFor',
    field: 'invoiceFor',
    sortable: false,
    title: translate('invoice_for', { namespace }),
    cell: LinkTableCell
  },
  building: {
    id: 'building',
    field: 'building',
    width: 250,
    title: translate('building', { namespace }),
    cell: LinkTableCell
  },
  issueDate: {
    id: 'issueDate',
    field: 'issueDate',
    title: translate('issue_date', { namespace }),
    cell: IssueDateCell
  },
  account: {
    id: 'account',
    field: 'account',
    sortable: false,
    title: translate('account', { namespace }),
    cell: LinkTableCell
  },
  technician: {
    id: 'technician',
    field: 'technician',
    title: translate('technician', { namespace })
  },
  status: {
    id: 'status',
    field: 'status',
    title: translate('status', { namespace })
  },
  invoiceAmount: {
    id: 'invoiceAmount',
    field: 'invoiceAmount',
    title: translate('invoice_amount', { namespace })
  },
  balance: {
    id: 'balance',
    field: 'balance',
    sortable: false,
    title: translate('balance', { namespace })
  },
  referenceNumber: {
    id: 'referenceNumber',
    field: 'referenceNumber',
    title: translate('reference_number', { namespace })
  },
  actions: {
    id: 'actions',
    field: 'actions',
    title: translate('actions', { namespace }),
    sortable: false,
    cell: ActionsCell
  }
};
